<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">
          Sub-Module Settings - {{ moduleName }}
        </div>
        <!-- <div>
            <bread-crumb :bread-crumbs="['Master Data']" />
          </div> -->
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>

      <v-card-text>
        <v-row class="mt-0">
          <v-col cols="12" md="3">
            <v-btn
              depressed
              color="primary"
              small
              @click="openDialog()"
              dark
              class="me-3 text-capitalize"
            >
              <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon
              >Add Sub-Module
            </v-btn>
            <v-btn depressed @click="downloadExcelsheet" color="primary" small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              single-line
              hide-details
              class="me-4"
              dense
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
        <v-card-title>
          <v-row class="">
            <!-- -------------------------------modal to add category ------------------- -->
            <v-dialog persistent max-width="400px" v-model="dialog">
              <v-card>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-toolbar dark color="#050048" flat dense>
                    <span class="subtitleFontsize">{{ formtitle }}</span>
                    <v-spacer></v-spacer>
                    <v-btn depressed small icon @click="onClickBack">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text class="">
                    <v-row>
                      <v-col cols="12" md="12">
                        <label class="my-0 mt-3 rounded labelFontsize required">
                          Sub-Module Name
                        </label>

                        <v-text-field
                          v-model="postData.name"
                          dense
                          outlined
                          placeholder="Name"
                          :rules="FieldRequired('Module Name')"
                          class="rounded"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label class="my-0 mt-3 rounded labelFontsize required">
                          API Description
                        </label>

                        <v-text-field
                          v-model="postData.api_description"
                          dense
                          outlined
                          placeholder="API Description"
                          :rules="FieldRequired('Module API Description')"
                          class="rounded"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <!-- <v-row class="">
                      <v-col cols="12" md="12">
                        <label class="my-0 rounded labelFontsize"> Description </label>
                        <v-text-field
                          v-model="postData.description"
                          placeholder="Description"
                          dense
                          outlined
                          class="rounded"
                        ></v-text-field>
                      </v-col>
                    </v-row> -->
                  </v-card-text>
                  <v-divider class="ma-0 pa-0"> </v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      depressed
                      small
                      color="primary"
                      @click="onSubmitFor()"
                      class="text-capitalize"
                    >
                      <v-icon small class="me-2"
                        >mdi-content-save-plus-outline</v-icon
                      >Save
                    </v-btn>

                    <v-btn
                      depressed
                      small
                      color="primary"
                      @click="onClickBack()"
                      class="text-capitalize"
                      outlined
                    >
                      <v-icon small class="me-2"
                        >mdi-close-circle-outline</v-icon
                      >
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </v-card-title>
        <!-- -----------------------category table Master Data------------------------- -->
        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          dense
          :search="search"
          class="mt-3 p-1"
          :items="ModulesList"
          :loading="isLoading"
          loading-text="Loading... Please wait"
        >
          <template v-slot:item.actions="{ item }">
            <div class="d-flex">
              <!-- <v-switch
                v-model="item.is_active"
                height="0px"
                title="Update Status"
                dense
                color="success"
                @change="isactiveupdate(item)"
              ></v-switch> -->
              <v-btn depressed icon title="Edit" @click="editItem(item)">
                <v-icon small color="primary">
                  mdi-content-save-edit-outline
                </v-icon>
              </v-btn>
              <v-btn depressed icon title="Delete" @click="deleteItem(item)">
                <v-icon small color="primary"> mdi-trash-can-outline </v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
        <!-- delete dialog -->
        <v-dialog persistent v-model="dialogDelete" width="500">
          <v-card>
            <v-card-title class="border border-bottom">Delete</v-card-title>
            <v-card-text class="h5 py-3"
              >Are you sure you want to delete?</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                small
                color="primary"
                outlined
                @click="deleteItemConfirm"
              >
                <v-icon>mdi-check</v-icon>
              </v-btn>
              <v-btn
                depressed
                small
                color="primary"
                outlined
                @click="(dialogDelete = false), (deleteId = null)"
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <loading :active="loader" :opacity="0.9" color="#ff6b00" />
      </v-card-text>
    </v-card>
  </section>
</template>
<script>
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
import { FieldRequired } from "@/utils/validation.js";
import userService from "@/services/UserService/userService.js";
// import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
// import setupService from "@/services/SetupService/setupService.js";

export default {
  mixins: [alerts],
  name: "sub-modules",
  data() {
    return {
      FieldRequired,
      dialogDelete: false,
      deleteId: null,
      dialog: false,
      valid: true,
      isLoading: false,
      loader: false,
      search: "",
      moduleName: "",
      headers: [
        {
          text: "Id",
          value: "id",
          width: 80,
          align: "start",
        },
        { text: "Sub-Module Name", value: "name", width: 250 },
        { text: "API Description", value: "api_description", width: 250 },
        {
          text: "Created by",
          value: "created_by",
          width: 250,
        },

        // { text: "Active", value: "is_active", sortable: false, width: 150 },
        { text: "Actions", value: "actions", sortable: false, width: 200 },
      ],
      postData: {
        name: "",
        api_description: "",
        created_by: 0,
        created_date: "",
        module_id: 0,
      },
      ModulesList: [],
      editedIndex: -1,
    };
  },

  components: {
    // BreadCrumb,
    Loading,
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add Module" : "Edit Module";
    },
  },

  mounted() {
    this.moduleName = this.$route.query.name;
    this.getSubModuleSummury();
  },

  watch: {},
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async downloadExcelsheet() {
      if (this.ModulesList) {
        this.exportToExcel(this.headers, this.ModulesList, "ModulesList");
      }
    },

    async getSubModuleSummury() {
      this.loader = true;
      try {
        const response = await userService.getAllSubModules(
          this.$route.query.id
        );
        if (response.data.status_code == 200) {
          this.ModulesList = response.data.data.reverse();
        }
        this.stoploader();
        console.log("Modules", this.ModulesList);
      } catch (e) {
        console.error(e);
        this.stoploader();
        this.showAlertError("Something went wrong please try again later.");
        this.ModulesList = [];
      }
    },

    async save() {
      this.loader = true;
      try {
        const response = await userService.postSubModule(this.postData);
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.getSubModuleSummury();
          this.onClickBack();
          this.stoploader();
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.loader = false;
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.loader = false;
      }
    },

    async update() {
      this.loader = true;
      try {
        const response = await userService.updateSubModule(
          this.postData.id,
          this.postData
        );
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.onClickBack();
          this.getSubModuleSummury();
          this.stoploader();
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.loader = false;
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.loader = false;
      }
    },
    onSubmitFor() {
      const validate = this.$refs.form.validate();
      if (validate) {
        if (this.postData.id) {
          this.update();
        } else {
          this.save();
        }
      }
    },

    openDialog() {
      this.editedIndex = -1;
      this.dialog = true;
      this.postData = {};
      this.postData.module_id = this.$route.query.id;
      console.log(this.postData);
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    editItem(item) {
      this.editedIndex = 1;
      this.dialog = true;
      this.postData = item;
      this.postData.module_id = this.$route.query.id;
    },
    onClickBack() {
      this.dialog = false;
      this.$refs.form.resetValidation();
    },
    deleteItem(item) {
      this.dialogDelete = true;
      this.deleteId = item.id;
    },

    async deleteItemConfirm() {
      this.loader = true;
      try {
        const response = await userService.deleteSubModule(this.deleteId);
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.dialogDelete = false;
          this.getSubModuleSummury();
          this.stoploader();
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.loader = false;
        }
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
